import * as React from 'react'
import FormattableTextField, { IFormattableTextFieldProps, IFormattableTextFieldState } from './FormattableTextField'

export interface IPostalCodeFieldProps extends IFormattableTextFieldProps {
    country: string
}

export default class PostalCodeField extends FormattableTextField<IPostalCodeFieldProps> {
    public static defaultProps: Partial<IPostalCodeFieldProps> = {
        label: 'Postcode',
        required: false,
    }

    public static getDerivedStateFromProps(
        nextProps: Readonly<IPostalCodeFieldProps>,
        prevState: Readonly<IFormattableTextFieldState>,
    ): IFormattableTextFieldState {
        return {
            ...prevState,
            value: prevState.format(nextProps.value, nextProps.country),
        }
    }

    protected onChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value: string): void {
        // Propagate to any parent event listeners.
        if (this.props.onChange) {
            this.props.onChange(event, this.state.format(value, this.props.country))
        }
    }

    protected format(value: string = '', country?: string): string {
        switch (country) {
            case 'NL':
                return (
                    value !== null &&
                    value
                        .replace(/^[^1-9]*([1-9]?)[^\d]*([\d]?)[^\d]*([\d]?)[^\d]*([\d]?)[^a-z]*([a-z]?)[^a-z]*([a-z]?).*$/gi, '$1$2$3$4 $5$6')
                        .toUpperCase()
                        .trim()
                )
            case 'BE':
                return value.replace(/[^\d]/g, '').replace(/^([\d]{4}).*/g, '$1')
            case 'DE':
                return value.replace(/[^\d]/g, '').replace(/^([\d]{5}).*/g, '$1')
        }
        return value
    }
}
